import dataApi from "./dataApiSlice";
import { ICompanyInfo }  from '../Types/OrganizationTypes'

const organizationApi = dataApi.injectEndpoints({
    endpoints: build => ({
        organizationData: build.query<ICompanyInfo[], string[]>({
            query: (orgNumbers) => ({
                url: 'organization?'.concat(orgNumbers.map(o => `organizationNumbers=${o}`).join('&')),
            })
        })
    })
});

export const { useOrganizationDataQuery } = organizationApi;